import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ItemPanel } from '../item-panel/item-panel';
import { Item, SelectionEvent as PanelSelectionEvent } from '../item-panel/item-panel.model';


// The specific interface for this component's data, defining capacity ranges in bytes.
export interface CapacityFilter {
  id: number;
  label: string;
  minBytes?: number;
  maxBytes?: number;
  selected?: boolean;
}

// This component's own event payload interface.
export interface CapacityFilterSelectionEvent {
  source: CapacityFilter | null;
  selected: CapacityFilter[];
}

@Component({
  selector: 'app-capacity-filter-panel',
  // The ItemPanel component is reused for the UI.
  imports: [
    ItemPanel
  ],
  templateUrl: './capacity-filter-panel.html',
  styleUrl: './capacity-filter-panel.scss'
})
export class CapacityFilterPanel implements OnInit {
  @Input() title: string = '';
  @Input() capacityFilterList: CapacityFilter[] = [];
  /** This component's own output, using its own specific event type. */
  @Output() selectionChanged = new EventEmitter<CapacityFilterSelectionEvent>();

  // This array is what gets passed to the generic ItemPanel component.
  panelItems: Item[] = [];

  ngOnInit(): void {
    // Maps the detailed CapacityFilter data to the generic Item structure needed by the child panel.
    this.panelItems = this.capacityFilterList.map(capacityFilter => ({
      id: capacityFilter.id,
      label: capacityFilter.label,
      selected: capacityFilter.selected ?? false,
    }));
  }

  /**
   * Handles the generic event from the child ItemPanel and maps it back
   * to a specific, detailed CapacityFilter event for the parent component (Home).
   */
  onPanelSelectionChange(panelEvent: PanelSelectionEvent): void {
    // 1. Find the full records for all selected items based on their IDs.
    const selectedIds = new Set(panelEvent.selectedItems.map(item => item.id));
    const selectedFilters = this.capacityFilterList.filter(capacityFilter =>
      selectedIds.has(capacityFilter.id)
    );

    // 2. Find the full record for the source item that was toggled.
    const sourceFilter = panelEvent.source
      ? this.capacityFilterList.find(p => p.id === panelEvent.source?.id) ?? null
      : null;

    // 3. Construct and emit this component's own, specific event payload.
    this.selectionChanged.emit({
      source: sourceFilter,
      selected: selectedFilters,
    });
  }
}
